
<template>


<div class="ma-6 pa-6 elevation-1">
    <div class="ma-3">

</div>
    <v-img
    class="pa-10 ma-10"
    contain
      :aspect-ratio="16/112"
      max-width="160"
      max-height="90"
      
      src="./../assets/nuage.png"
    ></v-img>
    <br>
    <div class="text-h2">
        The vending machine best friend
    </div>

<br>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="25"
      :rules="nameRules"
      label="Username"
      required
    ></v-text-field>

    <v-text-field
    type="password"
      v-model="password"
      :rules="passwordRules"
      label="Password"
      required
    ></v-text-field>



    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="validate"
    >
      Validate
    </v-btn>

    <v-btn
      color="error"
      class="mr-4"
      @click="reset"
    >
      Reset
    </v-btn>

  </v-form>
    <v-card
      class="text-caption d-flex justify-end mb-6"
      flat
      tile
    >V0.9.8</v-card>
      
</div>

</template>


<script>
import { store } from "@/models/Store.js";

  export default {
    data: () => ({
      store:store,
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 25) || 'Name must be less than 25 characters',
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Pasword is required',
      ]



    }),

    methods: {
      validate () {
        this.$refs.form.validate();
        //console.log(process.env.VUE_APP_API_EXT_URL);

                        if (this.password.length > 0) {
                    this.$http.post(process.env.VUE_APP_API_EXT_URL.split('API_EXT')[0] +'auth/API_EXT/login', {
                        username: this.name,
                        pwd: this.password
                    })
                    .then(response => {
                        console.log("response", response)
                        localStorage.setItem('jwt',response.data.token)
                        localStorage.setItem('idUser',response.data._id)
                      
                        if (localStorage.getItem('jwt') != null){

                          this.store.setIsCurrentUserAdmin(response.data.isAdmin)
                          this.store.setCurrentUsername(this.name)
                            this.$emit('loggedIn')
                            if(this.$route.params.nextUrl != null){
                                this.$router.push(this.$route.params.nextUrl)
                            }
                            else {
                               this.$router.push('/');
                                
                            }
                        }
                    })
                    .catch(function (error) {
                        alert("Authentification failed !\n status : "+error.response.status);
                        //console.log(error);
                        
                    })
                }

      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
